





































































































































import {
  Component,
  Vue,
} from 'vue-property-decorator';

import bButton from 'bootstrap-vue/es/components/button/button';
import bContainer from 'bootstrap-vue/es/components/layout/container';
import bImg from 'bootstrap-vue/es/components/image/img';
import bRow from 'bootstrap-vue/es/components/layout/row';
import bLink from 'bootstrap-vue/es/components/link/link';

import { Collection } from '@/models';

const CollectionListProps = Vue.extend({
  props: {
    heading: {
      type: String,
    },
    collections: {
      type: Array as () => Collection[],
      required: true,
    },
    collectionsPerRow: {
      type: Number,
      default: 3,
      validator: (value: number) => {
        return (value >= 2) && (value <= 5);
      },
    },
  },
});

@Component({
  components: {
    bButton,
    bContainer,
    bImg,
    bLink,
    bRow,
  },
})
export default class CollectionList extends CollectionListProps { }

